module.exports = __webpack_public_path__ + "img/location.c65bb2c9.png";